export default __webpack_public_path__ + "static/media/018.43c1e117.jpg";